export default __webpack_public_path__ + "static/media/logout.5c6d1f76.svg";